// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"76c60a2d","943":"7f1d3a96","958":"e6a9300e"}[chunkId] + ".chunk.js";
};